<template>
    <el-form ref="form" label-position="top">
         <el-row >
            <el-col :md="24" :lg="6">
                <el-form-item class="el-form-item-full" :label="$l('settings/download/statisticsTemplate')">
                    <el-select v-model="getUnsavedLocalSettings.download.downlStatistic" :placeholder="$l('common/select')">
                        <el-option v-for="item in mappedStatisticTemplates" v-bind:key="item.value" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <h4>{{$l('settings/download/statisticsRename')}}</h4>
                <el-form-item v-for="item in mappedStatisticTemplates" v-bind:key="item.value" class="el-form-item-full" :label="item.value">
                    <el-input :placeholder="$l('settings/statistics/reportSending/Name')" v-model="getUnsavedLocalSettings.download.statistics.mapping[item.value]"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-collapse accordion>
                <el-collapse-item :title="$l('settings/statistics/reportSending/settingsName')">
                    <el-row>
                        <el-row :gutter="10" style="margin-bottom:10px; padding-bottom:5px; border-bottom: 1px solid rgba(0,0,0,0.1)">
                            <el-col style="float:right" :md="1"><el-button  @click="addNewGroup()" size="small" type="success" style="float:right" icon="plus"></el-button></el-col>                  
                        </el-row>   
                        <el-form-item v-for="group in getSettingsStatistics.allgroups" v-bind:key="group" :class="(getScreenSize > 2)?'statiststics-table-item-container':''">
                            <el-row :gutter='10' :class="(getScreenSize > 2)?'statistics-table-item':''" style="border-bottom: 1px solid rgba(0,0,0,0.2);">
                                <el-col :lg="15">
                                    <el-row :gutter="10">
                                        <!--Name-->
                                        <el-col :md="24" :lg="6">
                                            <el-col >{{$l('settings/statistics/reportSending/Name')}}</el-col>
                                            <el-select :placeholder="$l('common/select')" v-model="getSettingsStatistics['templs'+group.replace('st','')]">
                                                <el-option v-for="item in mappedStatisticTemplates" v-bind:key="item.value" :value="item.value" :label="item.label"></el-option>
                                            </el-select>
                                        </el-col>
                                        <!--Title-->
                                        <el-col :md="24" :lg="7">
                                            <el-col>{{$l('settings/statistics/reportSending/Title')}}</el-col>
                                            <el-input :placeholder="$l('settings/statistics/reportSending/Title')" v-model="getSettingsStatistics['titles'+group.replace('st','')]"></el-input>
                                        </el-col>
                                        <!--Language-->
                                        <el-col :md="24" :lg="5">
                                            <el-col >{{$l('settings/statistics/reportSending/Language')}}</el-col>
                                            <el-select v-model="getSettingsStatistics['langs'+group.replace('st','')]" :placeholder="$l('common/select')">
                                                <el-option :label="$l('settings/interface/english')" value="en"></el-option>
                                                <el-option :label="$l('settings/interface/austria')" value="at"></el-option>
                                                <el-option :label="$l('settings/interface/german')" value="de"></el-option>
                                                <el-option :label="$l('settings/interface/french')" value="fr"></el-option>
                                                <el-option :label="$l('settings/interface/slovensko')" value="sl"></el-option>
                                            </el-select>
                                        </el-col>
                                        <!--Report type-->                                
                                        <el-col :md="24" :lg="6">
                                            <el-col>{{$l('settings/statistics/reportSending/Duration')}}</el-col>
                                            <el-select :placeholder="$l('common/select')" v-model="getSettingsStatistics['durs'+group.replace('st','')]">
                                                <el-option v-for="item in getSettingsStatistics.durations.split(',')" v-bind:key = "item" :value="item" :label="$l('settings/statistics/options/'+item)"></el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10" style="margin-top:10px; margin-bottom:10px">
                                       
                                        <!--Past Days-->
                                        <el-col v-if="getSettingsStatistics['durs'+group.replace('st','')] == 'Range'" :md="24" :lg="6">
                                            <el-col>{{$l('settings/statistics/reportSending/Range')}}</el-col>
                                            <div>
                                                <el-input-number class="range-numbers" v-model="getSettingsStatistics['ranges'+group.replace('st','')][0]"  :step='1' :max='31' :min='1'></el-input-number>
                                            </div>
                                        </el-col>
                                        <el-col v-else :md="24" :lg="6">
                                            <div v-if="getSettingsStatistics['durs'+group.replace('st','')] == 'Range'">
                                                <el-col>{{$l('settings/statistics/reportSending/Range')}}</el-col>
                                                <el-input-number class="range-numbers" v-model="getSettingsStatistics['ranges'+group.replace('st','')][0]"  :step='1' :max='31' :min='1'></el-input-number>
                                            </div>
                                        </el-col>
                                         <!--Hour-->
                                        <el-col :md="24" :lg="6">
                                            <el-col v-if="getSettingsStatistics['durs'+group.replace('st','')] != 'On Event'">{{$l('settings/statistics/reportSending/Hours')}}</el-col>
                                            <el-time-select style="width:100%" v-if="getSettingsStatistics['durs'+group.replace('st','')] != 'On Event'"
                                                v-model="getSettingsStatistics['hours'+group.replace('st','')]" 
                                                :picker-options="{
                                                    start: '00:00',
                                                    step: '01:00',
                                                    end: '24:00'
                                                }"
                                                :placeholder="$l('common/select')">
                                            </el-time-select>
                                        </el-col>
                                        <!--Email-->                                        
                                        <el-col  :md="24" :lg="8">
                                            <el-col >{{$l('settings/statistics/reportSending/Email')}}</el-col>
                                            <el-input :placeholder="$l('settings/statistics/reportSending/Email')" v-model="getSettingsStatistics['recps'+group.replace('st','')]"></el-input>
                                        </el-col>
                                    </el-row >
                                </el-col>
                                <el-col :lg="9" style="margin-bottom:10px; padding:0px">
                                    <!--Days-->
                                    <el-col :md="24">
                                        <el-col v-if=" getSettingsStatistics['durs'+group.replace('st','')] != 'On Event'">{{$l('settings/statistics/reportSending/Days')}}</el-col>
                                        <el-select v-if="getSettingsStatistics['durs'+group.replace('st','')] != 'On Event'" v-model="getSettingsStatistics['dayss'+group.replace('st','')]" multiple :placeholder="$l('common/select')">
                                            <el-option
                                            v-for="item in weekDays"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-col>
                                <el-col>
                                    <div class="delete-button-absolute" style="margin-right: 5px">
                                         <el-button  @click="alertGroupDeleted(group)" size="small" style="float:right" type="danger" icon="delete"></el-button>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-row>
    </el-form>
    
</template>

<style>
    .range-numbers{
        width: 100%;
    }
    .delete-button-absolute{
        position: absolute;
        top: 0px;
        right: 0px;
    }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            weekDays: [
                {value:"1",label:this.$l('common/graph_day_name')[1]},
                {value:"2",label:this.$l('common/graph_day_name')[2]},
                {value:"3",label:this.$l('common/graph_day_name')[3]},
                {value:"4",label:this.$l('common/graph_day_name')[4]},
                {value:"5",label:this.$l('common/graph_day_name')[5]},
                {value:"6",label:this.$l('common/graph_day_name')[6]},
                {value:"7",label:this.$l('common/graph_day_name')[0]}, 
            ],
            deleteLoading: false,
            form: {
                AutoDelete:'',
                ManualDelete:{
                    From:new Date(),
                    To:new Date() 
                },
                Values:{
                    Measurements:false,
                    Audio:false,
                    Weather:false,
                    IntegralValues:false,
                    Logs:false,
                    Statistics:false
                }
            }
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsSystem',
            'getSettingsAddons',

            'getSettingsDownload',
            'getSettingsDevice',
            'getSettingsWeather',
            'getUnsavedLocalSettings',
            'getSettingsSpecval',
            'getSettingsAddons',
            'getScreenSize',
            'getSettingsStatistics'
        ]),
        getId: function(group){
            return group.replace('st','');
        },
        mappedStatisticTemplates: function(){
            let templates = this.getSettingsStatistics.vallAll.split(',');
            let mapping = templates.map(t=>{
                let out = {
                    value:t,
                    label:t
                }
                try{
                    if(this.getUnsavedLocalSettings.download.statistics.mapping[t]){
                        out.label = this.getUnsavedLocalSettings.download.statistics.mapping[t];
                        
                    }
                }catch(err){
                    console.error(err);
                }
                return out;
            })
            return mapping;
        }
    },
    methods: {
        ...mapActions([
            'deleteOnInterval',
            'updateStatisticsSettings'
        ]),
        onSubmit() {
            this.deleteLoading = true;
            setTimeout(()=>{
                let values = getSettingsSystem.delvalsel.filter(val=>val.enabled).map(val=>val.name).join(',');
                this.deleteOnInterval({
                    From:this.form.ManualDelete.From,
                    To:this.form.ManualDelete.To,
                    Values:values
                });
                this.deleteLoading = false;
            },1500);
        },
        alertGroupDeleted(group){
            let id = group.replace('st','');
            let index = this.getSettingsStatistics.allgroups.indexOf(group);
            this.getSettingsStatistics.allgroups.splice(index,1);

            delete this.getSettingsStatistics['templs'+id];
            delete this.getSettingsStatistics['titles'+id];
            delete this.getSettingsStatistics['durs'+id];
            delete this.getSettingsStatistics['hours'+id];
            delete this.getSettingsStatistics['dayss'+id];
            delete this.getSettingsStatistics['ranges'+id];
            delete this.getSettingsStatistics['recps'+id];
            delete this.getSettingsStatistics['langs'+id];
        },
        addNewGroup(){
            let id = 1;
            this.getSettingsStatistics.allgroups.forEach(group=>{
                let gId = parseInt(group.replace('st',''));
                if (gId >= id){
                    id = gId+1;
                }
            })
            this.getSettingsStatistics.allgroups.push('st'+id);
            this.getSettingsStatistics['templs'+id] = 'Template1';
            this.getSettingsStatistics['titles'+id] = '';
            this.getSettingsStatistics['durs'+id] = 'Daily';
            this.getSettingsStatistics['hours'+id] = '08:00';
            this.getSettingsStatistics['dayss'+id] = ['1'];
            this.getSettingsStatistics['ranges'+id] = [0,0];
            this.getSettingsStatistics['recps'+id] = '';
            this.getSettingsStatistics['langs'+id] = 'en';
            //this.getSettingsStatistics = JSON.parse(JSON.stringify(this.getSettingsStatistics));
            this.updateStatisticsSettings(JSON.parse(JSON.stringify(this.getSettingsStatistics)));
        }
    }
}
</script>


// WEBPACK FOOTER //
// Statistics.vue?149c2722